module.exports = __webpack_public_path__ + "static/media/elephant.5bf39c03.png";